<div class="_editor-component">

    <div class="_variables-container">
        <div class="_variable" *ngFor="let variable of templateVariables" (click)="insertVariable(variable)">{{variable.translation}}</div>
    </div>

    <div class="_editor-container" *ngIf="form">
        <quill-editor 
            (onEditorCreated)="onEditorCreated($event)"
            [formControl]="form" 
            [format]="'html'"
            [formats]="[
                'background',
                'bold',
                'color',
                'font',
                'italic',
                'size',
                'strike',
                'script',
                'underline',
                'blockquote',
                'header',
                'indent',
                'list',
                'align',
                'direction',
                'variable',
                'width',
                'height',
                'style',
                type === 'text' ? 'link' : '',
                type !== 'sms' ? 'image' : ''
            ]"
            [sanitize]="false"
            [customOptions]="[{
                import: 'attributors/style/size',
                whitelist: ['10px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px']
            }]"
            [modules]="editorModules"
        ></quill-editor>
        <div *ngIf="type === 'sms'" id="counter">0/160 {{'CHARACTERS' | translate}}</div>
        
</div>